import React from 'react';

import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { allowListMessages } from 'src/features/allowList/utils/allowListMessages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import AllowListItemFormModal from 'src/features/allowListItem/components/forms/AllowListItemFormModal';
import { useCreateAllowListItem } from 'src/features/allowListItem/api/useCreateAllowListItem';
import { useParams } from 'react-router-dom';
import { LIST_ALLOW_LIST_ITEMS_RESOURCE } from 'src/features/allowListItem/api/useListAllowListItems';
import { useParking } from 'src/providers/ParkingProvider';

interface AllowListItemFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

export default function CreateAllowListItemFormModal<TData>({ className, semantics }: AllowListItemFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { listId = '' } = useParams();
    const { parkingId } = useParking()
    const { mutate, isPending } = useCreateAllowListItem({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ALLOW_LIST_ITEMS_RESOURCE] });
            toast({
                title: formatMessage(allowListMessages.createAllowListItemSuccess),
                description: formatMessage(allowListMessages.createAllowListItemSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <AllowListItemFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ listId, data: values, parkingId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={faPlus}
            isPending={isPending}
            subtitle={formatMessage(allowListMessages.addAllowListItemSubtitle)}
            listId={listId}
        />
    );
}
